module.exports = __webpack_public_path__ + "img/apple-appstore-badge-2018.54dc855.svg";